import { handleActions } from 'redux-actions';
import { END_DATE } from '../actionTypes';
import { rectify } from '../initialState';

export default handleActions(
  {
    [END_DATE]: (state, action) => {
      return {
        ...state,
        end_date: action.payload
      };
    }
  },
  rectify
);
